import React from 'react';
import { format } from 'date-fns';
import styles from './CardEventsDetails.module.css';
import ChevronIcon from '../icons/chevronIcon';
import { formatDatSemiShort, getLocale } from '../../helpers/dates';
import { useSelector } from 'react-redux';
import Image from '../Image/Image';

const CardEventsDetails = ({
  bannerImage,
  eventName,
  onClick,
  ticketpass,
  startDate,
  eventSubName,
  pax,
  reservationType,
}) => {
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);

  const reservationMessages = {
    AREA: `Zona vip - ${pax} personas`,
    RESTAURANT: `Reserva - ${pax} personas`,
    TICKET: `${pax} e-tickets`,
    UNDEFINED: '',
  };

  return (
    <div
      onClick={ticketpass ? null : onClick}
      className={`${styles.cardEvent} ${ticketpass ? styles.cardBlack : styles.cardWhite} p-2`}
    >
      <div className='row'>
        <div className='col-auto pr-0'>
          <Image
            className={styles.eventImg}
            src={bannerImage}
            alt={eventName}
            size='MEDIUM'
            progressive={true}
            width={80}
          />
        </div>

        <div className='col pl-2 pr-0 d-flex flex-column justify-content-between'>
          <div>
            <div className='fw-semibold'>{eventName}</div>
            <div className='font-tiny'>{eventSubName}</div>
          </div>
          <div>
            <div className='fw-semibold font-small'>
              {`${formatDatSemiShort(startDate, locale)}`} -{' '}
              {`${format(new Date(startDate), 'h:mm a')}`}
            </div>
            <div className='text-secondary font-tiny'>
              <span>{reservationMessages[reservationType] || reservationMessages.default}</span>
            </div>
          </div>
        </div>

        {!ticketpass && (
          <div className='col-auto pl-2 my-auto'>
            <ChevronIcon
              fillColor='#000'
              size={'20px'}
              styles={{
                transform: 'rotate(180deg)',
                marginTop: '-1px',
                marginLeft: '-2px',
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CardEventsDetails;
